import { configureStore } from "@reduxjs/toolkit";
import userDataSlice from "./slices/userDataSlice";
import patientsSlice from "./slices/patientsSlice";
import loaderSlice from "./slices/loaderSlice";
import workingPatternSlice from "./slices/workingPatternSlice";
import clientLeavesSlice from "./slices/clientLeaves";
import overtimeSlice from "./slices/overtimeSlice";
import permissionsSlice from "./slices/permissionsSlice";
import workLocationsSlice from "./slices/workLocationsSlice";
import reservationsSlice from "./slices/reservationsSlice";
import { financeApi } from "./api/financeApi";
import { orgDataApi } from "./api/orgDataApi";

const reducer = {
  userData: userDataSlice,
  patients: patientsSlice,
  loader: loaderSlice,
  workingPattern: workingPatternSlice,
  clientLeaves: clientLeavesSlice,
  overtime: overtimeSlice,
  permissions: permissionsSlice,
  workLocations: workLocationsSlice,
  reservations: reservationsSlice,
  [financeApi.reducerPath]: financeApi.reducer,
  [orgDataApi.reducerPath]: orgDataApi.reducer,
};
export default configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(financeApi.middleware, orgDataApi.middleware),
});
